<template>
    <app-layout class="file-layout">
        <div class="file-content">
            <div class="row align-center">
                <div class="column small-12 medium-10 large-8" v-if="material.id">
                    <h1 class="file-title">
                        <svg class="file-icon icon" :class="'icon-' + basicType"><use :xlink:href="'#' + basicType"></use></svg>
                        {{ material ? material.title : '' }}
                    </h1>
                    <p class="breadcrumb"><span class="crumb" v-for="(p, index) in path"><router-link :to="{ name: path.length - 1 > index ? 'category' : 'category-materials', params: { categoryNodeId: p.id } }">{{ p.category.title }}</router-link></span></p>
                    <p class="description">{{material.description}}</p>
                    <p class="description" v-if="material.type === 'link'"><a :href="material.uri" target="_blank">{{material.uri}}</a></p>
                    <div class="button-toolbar">
                        <button v-if="isMyMaterial" class="button success hollow" type="button" @click="remove()">Dzēst</button>
                        <router-link v-if="isMyMaterial" :to="{ name: 'material-edit', params: { id: material.id } }" class="button success">Mainīt</router-link>
                        <button v-if="material.type === 'file'" type="button" class="button success" @click="download()">Lejuplādēt</button>
                        <button v-if="material.type === 'file'" type="button" class="button success" @click="showPreview = !showPreview">{{ showPreview ? 'Aizvērt' : 'Apskatīt' }}</button>
                        <a v-else :href="material.uri" class="button success" target="_blank">Apskatīt</a>
                        <template v-if="!isMyMaterial">
                            <button class="button clear secondary" @click="like()"><svg-icon :symbol="likeIcon" class="icon-inline" :class="{ 'icon-like-active': material.is_liked }"></svg-icon><span>Patīk</span></button>
                            <button class="button clear secondary" @click="bookmark()"><svg-icon :symbol="bookmarkIcon" class="icon-inline" :class="{ 'icon-bookmark-active': material.has_bookmark }"></svg-icon><span>Pievienot grāmatzīmi</span></button>
                        </template>
                    </div>
                    <hr/>
                    <div class="file-details">
                        <router-link v-if="material.signature_type == 'name'" :to="{ name: 'profiles', params: { id: material.owner.id } }" class="file-author"><avatar :avatar="material.owner.avatar" class="avatar"></avatar><span>{{ material ? material.signature : '' }}</span></router-link>
                        <span v-else class="file-author"><avatar class="avatar"></avatar><span>{{ material ? material.signature : '' }}</span></span>
                        <span class="file-created-at">Publicēts: {{ material ? material.created_at : '' | moment("DD/MM/YYYY") }}</span>
                    </div>

                    <preview v-if="showPreview" :materialId="material.id"></preview>

                    <comments :material="material"></comments>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '../layouts/AppLayout'
    import SvgIcon from '../components/SvgIcon'
    import Avatar from '../components/Avatar'
    import materials from '../api/materials'
    import Comments from '../components/Comments'
    import { mapGetters } from 'vuex'
    import Preview from '../components/materials/MaterialPreview'

    import avatarIcon from '../../icons/icon-avatar.svg-sprite'
    import bookmarkIcon from '../../icons/icon-bookmark.svg-sprite'
    import likeIcon from '../../icons/icon-like.svg-sprite'

    export default {

        props: ['id'],

        created: function () {

            // Record view statistics
            this.getMaterial()
                .then(response => materials.addView(this.material.id))
        },

        data: function () {
            return {
                avatarIcon,
                bookmarkIcon,
                likeIcon,
                material: {
                    id: null,
                    title: null,
                    created_at: null,
                    mime_type: null,
                    type: null,
                    is_liked: null,
                    has_bookmark: null,
                    categories: []
                },
                basicType: '',
                path: [],
                showPreview: false
            }
        },

        methods: {
            /**
             * Remove a material and go to the previous page.
             */
            remove() {
                materials.delete(this.material.id)
                    .then(r => {
                        this.$notify({ title: 'Materiāls izdzēsts!', type: 'success' });
                        this.$router.go(-1)
                    });
            },

            /**
             * Request download url and download the material.
             */
            download() {
                materials.download(this.material);
            },

            /**
             * Like the material
             */
            like() {
                const method = this.material.is_liked ? 'removeLike' : 'addLike';
                materials[method](this.material.id)
                    .then(response => {
                        if (response.data.data.is_liked) {
                            this.$notify({title: 'Patīk atzīme pievienota!', type: 'success'});
                        } else {
                            this.$notify({title: 'Patīk atzīme noņemta!'});
                        }
                        Object.assign(this.material, response.data.data);
                        return response;
                    })
            },

            /**
             * Add the material to bookmarks.
             */
            bookmark() {
                const method = this.material.has_bookmark ? 'removeBookmark' : 'addBookmark';
                materials[method](this.material.id)
                    .then(response => {
                        if (response.data.data.has_bookmark) {
                            this.$notify({ title: 'Grāmatzīme pievienota!', text: 'Grāmatzīmes vari atrast savā profila lapā.', type: 'success' });
                        } else {
                            this.$notify({ title: 'Grāmatzīme noņemta!' });
                        }
                        Object.assign(this.material, response.data.data);
                        return response;
                    });
            },

            /**
             * Get the material for current route parameter.
             * @returns {Promise<T>}
             */
            getMaterial() {
                return materials.find(this.id)
                    .then(response => {
                        this.material = response.data.data;
                        this.path = this.getCategoryNodesPath(this.material.categories);
                        return response;
                    });
            },

            /**
             * Get material categories and construct a breadcrumb.
             * FIXME unreliable, maybe use context as category identifier eg. material opened under category X
             * @param categories
             * @returns {Array}
             */
            getCategoryNodesPath(categories) {
                const path = [];

                //It is assumed that parent has only one node
                const parentCategory = categories
                    .find(c => c.nodes.length === 1 && c.nodes[0].parent_id === null);

                let parentNode = parentCategory.nodes[0];
                parentNode.category = parentCategory;
                path.push(parentNode);

                function getChildNode(p, cats) {
                    for (let i = 0, len = cats.length; i < len; i++) {
                        const node = cats[i].nodes.find(n => n.parent_id === p.id);
                        if (node) {
                            node.category = cats[i];
                            return node;
                        }
                    }
                    return null;
                }

                while (parentNode = getChildNode(parentNode, categories)) {
                    path.push(parentNode);
                }

                return path;
            }
        },

        computed: {

            ...mapGetters(['user']),

            /**
             * Check if this material belongs to currently logged in user.
             * @returns {boolean}
             */
            isMyMaterial() {
                return this.user && this.material && this.user.id === this.material.owner.id;
            }
        },

        watch: {

            'id': function (val, oldVal) {
                console.log('watch.id', val, oldVal);
                if (val) {
                    this.getMaterial();
                }
            },

            'material': function (val, oldVal) {
                //TODO fix material.type and material.mime_type changes which are not watched now...
                this.basicType = materials.basicType(val);
            }
        },

        components: { AppLayout, SvgIcon, Avatar, Comments, Preview }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .file-content {
        margin: rem-calc(80px) 0;
    }

    h1.file-title {
        @include clearfix;

        font-size: 30px;
        margin-bottom: 1rem;
        padding-left: px-em(90px, 30px);
        position: relative;
        line-height: 1.2;
        min-height: 60px;

        .file-icon {
            width: 60px;
            height: 60px;
            margin-right: 30px;
            position: absolute;
            left: 0;
        }
    }

    .file-author {
        font-weight: 700;
        margin-right: 1rem;

        .avatar {
            width: 50px;
            height: 50px;
            vertical-align: middle;
            margin-right: 0.5em;
        }
    }

    .file-details {
        margin-bottom: 1rem;
    }

    .file-created-at {
        color: #999999;
    }

    .breadcrumb {
        font-weight: 700;
        font-size: rem-calc(13px);
        color: #999999;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Material.vue